import { render, staticRenderFns } from "./DiligenceGuide.vue?vue&type=template&id=bdc170b4&scoped=true"
import script from "./DiligenceGuide.vue?vue&type=script&lang=js"
export * from "./DiligenceGuide.vue?vue&type=script&lang=js"
import style0 from "./DiligenceGuide.vue?vue&type=style&index=0&id=bdc170b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc170b4",
  null
  
)

export default component.exports